// debounce.js
/**
 * 防抖函数封装
 * @param {Function} fn - 需要防抖处理的函数
 * @param {number} delay - 延迟时间（毫秒）
 * @param {boolean} immediate - 是否立即执行（true: 先执行后防抖，false: 先防抖后执行）
 * @returns {Function} - 返回防抖处理后的函数
 */
export function debounce(fn, delay = 300, immediate = false) {
  // 存储定时器ID
  let timer = null
  // 标记是否已经立即执行过
  let isImmediateExecuted = false

  // 返回防抖处理后的函数
  return (...args) => {
    // 清除已有的定时器
    if (timer) {
      clearTimeout(timer)
      timer = null
    }

    // 立即执行模式
    if (immediate && !isImmediateExecuted) {
      // 立即执行函数
      fn.apply(this, args)
      isImmediateExecuted = true

      // 延迟一段时间后重置标志，允许下次立即执行
      timer = setTimeout(() => {
        isImmediateExecuted = false
        timer = null
      }, delay)
    }
    // 非立即执行模式（默认）
    else {
      // 设置新的定时器
      timer = setTimeout(() => {
        fn.apply(this, args)
        timer = null
        isImmediateExecuted = false
      }, delay)
    }
  }
}
